import { formatMoney } from "../../../../utils/formatters";
import { hasValue } from "../../helpers/decisionNarrativeHelpers";
import { SectionHeading } from "./NarrativePresentation";

export const UnresolvedPortfolioExposure = ({ decision, currency, riskAppetite, position, remainingBudget, unfundedCapitalAtRisk }) => {
  if (!decision) return null;

  const outsideAppetite = riskAppetite?.not_met_count;

  return (
    <section aria-labelledby="unresolved-exposure-title" className="rounded-2xl border border-amber-200 bg-amber-50/60 p-6 shadow-sm">
      <SectionHeading eyebrow="What exposure and decisions remain after this recommendation?" title="What Remains Unresolved" id="unresolved-exposure-title" description="The recommendation improves the modeled portfolio position but does not remove every material exposure or funding constraint." />
      <div className="mt-5 space-y-2 text-sm leading-6 text-amber-900">
        {position?.summary && <p>{position.summary}</p>}
        <p>
          {hasValue(unfundedCapitalAtRisk) && <><strong>{formatMoney(unfundedCapitalAtRisk, currency)}</strong> remains as unfunded Capital at Risk. </>}
          {hasValue(outsideAppetite) && <><strong>{outsideAppetite}</strong> scenarios remain outside their defined risk appetite. </>}
          {hasValue(remainingBudget) && <><strong>{formatMoney(remainingBudget, currency)}</strong> of the available budget remains unallocated.</>}
        </p>
        {hasValue(outsideAppetite) && Number(outsideAppetite) > 0 && (
          <p>
            Scenario appetite gaps remain partially unresolved under the available capital constraint. Additional treatment may require more capital or different decisions.
          </p>
        )}
      </div>
    </section>
  );
};
